import { render, staticRenderFns } from "./ConfigList.vue?vue&type=template&id=83172f94&scoped=true"
import script from "./ConfigList.vue?vue&type=script&lang=js"
export * from "./ConfigList.vue?vue&type=script&lang=js"
import style0 from "./ConfigList.vue?vue&type=style&index=0&id=83172f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83172f94",
  null
  
)

export default component.exports